import { formatMillisecondsAsMMSS } from '@components/ScreenerResults/utils';

export const getCsvData = (
  answers: NonNullable<ScreenerResponseAnswerValue<'prototype_test'>>[],
  testType?: string
) => {
  return answers.map((answer) => {
    const totalTime = answer.time_in_task !== null ? formatMillisecondsAsMMSS(answer.time_in_task) : '00:00';

    return {
      name: answer.participation_name || 'Unnamed',
      total_time: totalTime,
      successful: testType === 'goal-based' ? (answer.completed ? 'Yes' : 'No') : 'N/A',
      mis_click_rate: testType === 'goal-based' ? `${answer.miss_clicks ? answer.miss_clicks.toFixed(1) : 0}%` : 'N/A'
    };
  });
};
